import React from 'react';
import PropTypes from 'prop-types';
import AnonFooter from './AnonFooter';
import AuthedFooter from './AuthedFooter';

import './footer.scss';

const SMFooter = ({
  isUserAuthenticated,
  lang,
  domain,
  country,
  variant,
  showBillingAddress,
  isEUDC,
  tld
}) => {
  return (
    <>
      <Choose>
        <When condition={isUserAuthenticated}>
          <AuthedFooter
            lang={lang}
            domain={domain}
            showBillingAddress={showBillingAddress}
            country={country}
            isEUDC={isEUDC}
          />
        </When>
        <Otherwise>
          <AnonFooter
            lang={lang}
            domain={domain}
            country={country}
            variant={variant}
            isEUDC={isEUDC}
            tld={tld}
          />
        </Otherwise>
      </Choose>
    </>
  );
};

SMFooter.propTypes = {
  isUserAuthenticated: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  showBillingAddress: PropTypes.bool,
  variant: PropTypes.string,
  isEUDC: PropTypes.bool.isRequired,
  tld: PropTypes.string.isRequired
};

SMFooter.defaultProps = {
  showBillingAddress: false,
  variant: 'default'
};

export default SMFooter;
